import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import './index.scss';
import { useTranslation } from 'react-i18next'
import { useGetOrderQuery, useShowOrderQuery } from '../../../services/membership';
import { useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Host from '../../../Components/Host';
import { Tag } from "antd";
import OrdersList from './OrdersList';
import SideMenu from '../SideMenu';
import CircularProgress from '@mui/material/CircularProgress';
import formatPrice from '../../../Components/formatPrice';
var moment = require('moment');
function Order() {
  const { userId, userToken, userEmail, countryCode } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation()
  const { orderNumber } = useParams();
  if (!userEmail && !userToken) {
    history.push('/')
  }
  const page = new URLSearchParams(location.search).get('page') || 1
  const limit = new URLSearchParams(location.search).get('size') || 24
  const membership = useShowOrderQuery({
    userId: userId,
    orderNumber: orderNumber,
    userToken: userToken,
    domain: Host?.domain,
    countryCode: countryCode
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const orderData = membership?.data?.order

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, [])



  function fetchOrderStatus(state, status) {
    if (status) {
      if (state == 'request_cancel') {
        return <span className='badge badge-warning'>Requested for cancellation</span>
      } else if (state == 'cancelled') {
        return <span className='badge badge-danger'>Cancelled</span>
      } else {
        return <span className='badge badge-success'>Confirmed</span>
      }
    } else {
      return <span className='badge badge-warning'>Payment pending</span>
    }
  }

  return (
    <div className="Account-page tabel_cards">
      <div className="container">
        <div className='account-section'>
          <SideMenu />
          <div className='op-section' style={{ width: '100%' }}>
            <div className="row" style={{ justifyContent: 'center' }}>
              {membership?.isLoading ?
                <div className='col-md-12' style={{ textAlign: 'center' }}>
                  <CircularProgress style={{ width: '2rem', height: '2rem', color: '#000' }} />
                </div> :
                <>
                  <div className='col-md-12'>
                    <div className="ap-title">Order Item Details</div>
                    <div className='row'>
                      <div className='col-md-8'>
                        <div className='op-card' style={{border: 'none', background: '#fff0', padding: 0}}>
                          <OrdersList orders={orderData} />
                        </div>
                      </div>

                      <div className='col-md-4'>
                        <div className='op-card'>
                          <div>
                            <h4 className="ap-title" style={{ textAlign: 'left', padding: '0px', fontSize: '1rem' }}>Order Summary</h4>
                          </div>
                          <br />
                          <div className='o-summary-l'>
                            <span style={{ fontWeight: 500 }}>{t('order_placed_on')}: </span>
                            <span>{moment(orderData?.createdAt).format("MMM Do YYYY")}</span>
                          </div>
                          <div className='o-summary-l'>
                            <span style={{ fontWeight: 500 }}>{t('order_status')}: </span>
                            {fetchOrderStatus(orderData?.states, orderData?.status)}
                          </div>
                          <div className='o-summary-l'>
                            <span style={{ fontWeight: 500 }}>{t('order_number')}: </span>
                            <span>{orderData?.order_number}</span>
                          </div>
                          <div className='o-summary-l'>
                            <span style={{ fontWeight: 500 }}>{t('total_items')}: </span>
                            <span>{orderData?.order_items?.length}</span>
                          </div>
                          <div className='o-summary-l'>
                            <span style={{ fontWeight: 500 }}>{t('subtotal')}: </span>
                            <span>{formatPrice(orderData?.amount, orderData?.currency, 0)}</span>
                          </div>
                          {orderData?.coupon?.coupon_code &&
                            <div className='o-summary-l'>
                              <span style={{ fontWeight: 500 }}>{t('discount')}: </span>
                              <span>-{formatPrice(orderData?.coupon?.discount, orderData?.currency, 0)}</span>
                            </div>
                          }
                          <div className='o-summary-l'>
                            <span style={{ fontWeight: 500 }}>{t('shipping_fee')}:</span>
                            <span>{orderData?.currency} {orderData?.shipping_price === 0 ? 'FREE' : `+${orderData?.shipping_price}`}</span>
                          </div>
                          <div className='o-summary-l'>
                            <span style={{ fontWeight: 500 }}>{t('total')}: </span>
                            <span>
                              {formatPrice(orderData?.amount, orderData?.currency, orderData?.shipping_price)}
                            </span>
                          </div>
                        </div>
                        {orderData?.shipping_address?.name &&
                          <div className='op-card'>
                            <div>
                              <h4 className="ap-title" style={{ textAlign: 'left', padding: '0px', fontSize: '1rem' }}>
                                Delivery Address</h4>
                            </div>
                            <br />
                            <div className='o-summary-l' style={{ justifyContent: 'flex-start' }}>
                              <span style={{ fontWeight: 500 }}>{t('Name')}: </span>
                              <span>{orderData?.shipping_address?.name}</span>
                            </div>
                            <div className='o-summary-l' style={{ justifyContent: 'flex-start' }}>
                              <span style={{ fontWeight: 500 }}>{t('Email')}: </span>
                              <span>{orderData?.shipping_address?.email}</span>
                            </div>
                            <div className='o-summary-l' style={{ justifyContent: 'flex-start' }}>
                              <span style={{ fontWeight: 500 }}>{t('Phone')}: </span>
                              <span>{orderData?.shipping_address?.phone}</span>
                            </div>
                            <div className='o-summary-l' style={{ justifyContent: 'flex-start' }}>
                              <span style={{ fontWeight: 500 }}>{t('Address')}: </span>
                              <span>
                                {orderData?.shipping_address?.address},
                                {orderData?.shipping_address?.street}
                              </span>
                            </div>
                            <div className='o-summary-l' style={{ justifyContent: 'flex-start' }}>
                              <span style={{ fontWeight: 500 }}>{t('City')}: </span>
                              <span>{orderData?.shipping_address?.city}</span>
                            </div>

                            <div className='o-summary-l' style={{ justifyContent: 'flex-start' }}>
                              <span style={{ fontWeight: 500 }}>{t('Country')}: </span>
                              <span>{orderData?.shipping_address?.country}</span>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Order;